/* tslint:disable */
/* eslint-disable */

/**
 * 1 = Radii
 * 
 * 2 = Linear
 * 
 * 3 = Diameter
 * 
 * 4 = SurfaceFinish
 * 
 * 5 = Parallelism
 */
export enum DimensionType {
  Radii = 1,
  Linear = 2,
  Diameter = 3,
  SurfaceFinish = 4,
  Parallelism = 5
}
